import { CollisionDetection, pointerWithin, rectIntersection } from "@dnd-kit/core";
import { MenuItemPreviewSearchFragment } from "apps/web/src/types";
import { MenuBuilderMenuItemType } from "../Meal/MenuBuilderMealSchema";

export const PANEL_MENU_ITEM_DRAG_TYPE = "panelMenuItem" as const;
export const DAY_CELL_DROP_TYPE = "dayCell" as const;

export type PanelMenuItemDragData = {
  type: typeof PANEL_MENU_ITEM_DRAG_TYPE;
  menuItem: MenuItemPreviewSearchFragment;
};

export type DayCellDropData = {
  type: typeof DAY_CELL_DROP_TYPE;
  addRowItem: (menuItem: MenuBuilderMenuItemType) => void;
  usedMenuItemIds: readonly string[];
};

export const panelMenuItemDragId = (menuItemId: string) => `panel-menu-item:${menuItemId}`;

export const toMenuBuilderMenuItem = (menuItem: MenuItemPreviewSearchFragment): MenuBuilderMenuItemType => ({
  id: menuItem.id,
  name: menuItem.name,
  isMissingIngredients: menuItem.isMissingIngredients,
});

export const isPanelMenuItemDragData = (data: unknown): data is PanelMenuItemDragData =>
  typeof data === "object" && data !== null && (data as PanelMenuItemDragData).type === PANEL_MENU_ITEM_DRAG_TYPE;

export const isDayCellDropData = (data: unknown): data is DayCellDropData =>
  typeof data === "object" && data !== null && (data as DayCellDropData).type === DAY_CELL_DROP_TYPE;

/** Prefer pointer hits; fall back to rect intersection so keyboard dragging can resolve a target. */
export const panelToCellCollisionDetection: CollisionDetection = args => {
  const pointerCollisions = pointerWithin(args);
  if (pointerCollisions.length > 0) {
    return pointerCollisions;
  }
  return rectIntersection(args);
};
